import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "rightWrap"
};
const _hoisted_2 = {
  class: "titlebox"
};
const _hoisted_3 = {
  class: "contentwrap"
};
const _hoisted_4 = {
  class: "bottombutton"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.isadd ? '新增路线分类' : '编辑路线分类'), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
    ref: "formdata",
    model: $props.form
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: $props.formlabel.title,
      prop: "title",
      rules: [{
        required: true,
        message: `请填写${$props.formlabel.title}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.form.title = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      class: "hide",
      label: $props.formlabel.onlyid,
      prop: "onlyid"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.onlyid,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $props.form.onlyid = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.sortId,
      prop: "sortId"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        modelValue: $props.form.sortId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $props.form.sortId = $event),
        min: 0,
        "controls-position": "right"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
    onClick: _cache[3] || (_cache[3] = $event => $data.dialogVisible = false)
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
    _: 1
  }), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.savetypeHandle
  }, {
    default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("确定")])),
    _: 1
  }, 8, ["onClick"])])], 512)), [[_vShow, $data.dialogVisible]]);
}